import type { JSX, SVGProps } from "react";
import { cn } from "@/lib/utils";

/** Ghost mark from old app `timeghost_logo.svg` (currentColor body + contrasting eyes). */
export default function TimeghostMark({ className, ...props }: SVGProps<SVGSVGElement>): JSX.Element {
	return (
		<svg
			aria-hidden
			className={cn("timeghost-mark shrink-0", className)}
			viewBox="0 0 350 320"
			xmlns="http://www.w3.org/2000/svg"
			{...props}>
			<path
				className="logo-body"
				d="M0 140C0 93 13.95 0 146.95 0C273.95 0 286.95 49.5 278.95 124C271.262 195.595 281 218 304 218C341 218 338.5 196 348 201C356.313 205.375 319.95 283 258.95 306C206.708 325.698 115.95 327 67.95 285C7.73208 232.309 0 179.5 0 140Z"
				fill="currentColor"
			/>
			<path
				className="logo-eyes"
				d="M156.306 139C169.009 139 179.306 123.777 179.306 105C179.306 86.2219 169.009 70.9996 156.306 70.9996C143.604 70.9996 133.306 86.2219 133.306 105C133.306 123.777 143.604 139 156.306 139Z"
			/>
			<path
				className="logo-eyes"
				d="M220.459 131.679C229.503 130.569 235.144 115.893 233.058 98.8994C230.971 81.9062 221.948 69.0308 212.903 70.1413C203.858 71.2519 198.217 85.9279 200.304 102.921C202.39 119.914 211.414 132.79 220.459 131.679Z"
			/>
		</svg>
	);
}
